// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .settings {
  background-color: #f6f3f3;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
}
.theme-light .settings .settingsContent {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  padding: 20px;
  border-radius: 10px;
  color: #000;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
.theme-dark .settings {
  background-color: #333;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
}
.theme-dark .settings .settingsContent {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 20px;
  padding: 20px;
  border-radius: 10px;
  color: #fffef9;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/settings/settings.scss"],"names":[],"mappings":"AAqBI;ECjBA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAFJ;AAII;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yCAAA;AAFR;ADMI;ECjBA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAcJ;AAZI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,yCAAA;AAcR","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.settings {\n  @include themify($themes) {\n    background-color: themed(\"bgSoft\");\n    padding-left: 20px;\n    display: flex;\n    flex-direction: column;\n\n    .settingsContent{\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        margin-top: 20px;\n        padding: 20px;\n        border-radius: 10px;\n        color: themed(\"textColor\");\n        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n    \n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
